import type { DemoSurface } from "@verity-connect/contracts";

export interface DemoSurfaceDefinition {
  id: DemoSurface;
  label: string;
  detail: string;
  icon: "screen" | "school" | "person" | "association" | "phone";
}

/** One list feeds both the platform launcher and the demo control bar. */
export const DEMO_SURFACES: readonly DemoSurfaceDefinition[] = [
  { id: "organizer", label: "Staff", detail: "Run the association and event", icon: "screen" },
  { id: "school", label: "School", detail: "Manage a member school", icon: "school" },
  { id: "presenter", label: "Presenter", detail: "Share materials", icon: "person" },
  { id: "exhibitor", label: "Exhibitor", detail: "Manage an event profile", icon: "association" },
  { id: "attendee", label: "Attendee", detail: "Use the convention app", icon: "phone" },
];

export function demoSurfaceFromPath(pathname: string): DemoSurface {
  if (pathname.startsWith("/staff")) return "organizer";
  if (pathname.startsWith("/school")) return "school";
  if (pathname.startsWith("/presenter")) return "presenter";
  if (pathname.startsWith("/exhibitor")) return "exhibitor";
  return "attendee";
}
